import styled from 'styled-components';

// Colores neutros fijos (NO dependen de theme): el splash se renderiza también
// FUERA de <ThemeProvider> (PersistGate.loading en App.tsx lo envuelve), donde
// `theme` llega undefined a los styled-components. Mismos valores que el
// manifest PWA (vite.config.js: theme_color/background_color) para que el
// splash case con el color de arranque del navegador/SO.
export const SPLASH_BACKGROUND_COLOR = '#f5f5ff';
export const SPLASH_ACCENT_COLOR = '#4a4a8a';

export const SplashScreenContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  background-color: ${SPLASH_BACKGROUND_COLOR};

  /* El Loader canónico (src/components/inputs/Loader) trae 'margin: auto'
     para autocentrarse cuando se usa suelto (modales, tablas). Dentro de
     este flex-column ese auto-margin ABSORBE todo el espacio libre vertical
     y anula el justify-content, empujando el "Cargando..." al fondo de la
     pantalla (feedback usuario 2026-07-21: loader en medio, texto abajo del
     todo). Lo neutralizamos SOLO aquí — el ThemeProvider no renderiza DOM,
     así que el LoaderContainer es hijo directo. El gap 2.5rem deja hueco
     para la sombra absoluta del loader (::before a 6rem) antes del texto. */
  & > [role='progressbar'] {
    margin: 0;
  }
`;

export const SplashScreenText = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  color: ${SPLASH_ACCENT_COLOR};
  text-align: center;
`;
